import { Container, Typography } from '@evocolabs/orkaui'
import { Box, Stack } from '@mui/material'
import Image from 'next/image'
import { SectionTitle } from '../title'
import { getImage } from '@/src/utils/media'
import {
  AppStoreBadgePC,
  GooglePlayBadgePC
} from '@/src/components/DownloadableBadge'

const data = {
  title: 'Orka Health App',
  content: `In-app hearing screening, onboarding tutorial, real-time adjusting
  your hearing aids, and connect with Hearing Care Professionals,
  any time anywhere.`
}

const AppDownload = (): JSX.Element => {
  return (
    <Stack
      direction={{ xs: 'column', dl: 'row-reverse' }}
      alignItems={{ xs: 'flex-start', dl: 'center' }}
      width="100%"
      mt={{ xs: 0, dl: 7 }}
      position="relative"
    >
      <Container
        sx={{
          position: { xs: 'static', dl: 'absolute' },
          left: 0,
          right: 0
        }}
      >
        <Stack mb={3} width={{ xs: '100%', dl: '55%' }}>
          <SectionTitle textAlign="left">{data.title}</SectionTitle>
          <Typography
            variant="body2"
            color="black"
            mt={2}
            mb={{ xs: 3, dl: 5 }}
          >
            {data.content}
          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 2, sm: 3 }}
          >
            <Box height="56px">
              <AppStoreBadgePC />
            </Box>
            <Box height="56px">
              <GooglePlayBadgePC />
            </Box>
          </Stack>
        </Stack>
      </Container>
      <Box
        position="relative"
        width={{ xs: '100%', dl: '45%' }}
        paddingBottom={{ xs: '100%', dl: '45%' }}
        maxWidth="800px"
        alignSelf={'flex-end'}
      >
        <Image
          src={getImage('App.png', 'PC', 'website/orkaCare')}
          alt={data.title}
          fill
          style={{ objectFit: 'contain' }}
          unoptimized
        />
      </Box>
    </Stack>
  )
}

export default AppDownload
